export default {
  // ── fans/page.tsx ──
  'fans.hero.title': 'VOCES DE IMPACTO',
  'fans.hero.subtitle': 'PERSONAS REALES. HISTORIAS REALES. UN IMPACTO GLOBAL.',
  'fans.hero.body': 'Detrás de cada titular hay personas cuyas vidas han sido influenciadas por los mensajes de Andrew y Tristan Tate sobre disciplina, responsabilidad, fortaleza física, familia, fe, resiliencia y superación personal. Estas son sus palabras.',
  'fans.hero.disclaimer': 'Los testimonios reflejan las opiniones personales y experiencias de sus respectivos autores. Tate Protest no verifica de forma independiente cada declaración o afirmación.',
  'fans.hero.imgAlt': 'Seguidores de todo el mundo unidos en solidaridad',
  'fans.hero.imgTitle': 'Voces de Impacto – Seguidores de Tate en solidaridad global',

  'fans.seo.title': 'Voces de Impacto | Testimonios de seguidores de Tate | Tate Protest',
  'fans.seo.description': 'Lee historias personales de personas que atribuyen a Andrew y Tristan Tate influencia en su disciplina, condición física, resiliencia mental, negocios, fe, relaciones familiares y sentido de propósito.',
  'fans.seo.keywords': 'testimonios de seguidores de Tate, voces de impacto, historias de seguidores de Andrew Tate, impacto de Tristan Tate, comunidad de Tate Protest, transformación personal, disciplina, condición física, fe',
  'fans.seo.aboutName': 'Testimonios de seguidores de los hermanos Tate',
  'fans.seo.aboutDescription': 'Una colección de relatos en primera persona de personas que describen el impacto de Andrew y Tristan Tate en sus vidas.',

  'fans.allTestimonials.label': 'TODOS LOS TESTIMONIOS',
  'fans.allTestimonials.body': 'Explora la colección completa de historias de seguidores. Usa los filtros para navegar por tema.',

  // ── CommunityVoicesSection ──
  'fans.community.label': 'VOCES DE LA COMUNIDAD',
  'fans.community.body': 'Una selección de voces de seguidores de toda la comunidad.',

  // ── FeaturedStories ──
  'fans.featured.label': 'HISTORIAS DE TRANSFORMACIÓN DESTACADAS',
  'fans.featured.body': 'Relatos personales detallados de cómo el mensaje de Andrew y Tristan Tate inspiró cambios significativos.',
  'fans.featured.readFull': 'LEER TESTIMONIO COMPLETO',
  'fans.featured.collapse': 'COLAPSAR',
  'fans.featured.ariaExpand': 'Leer testimonio completo',
  'fans.featured.ariaCollapse': 'Colapsar testimonio',
  'fans.featured.defaultLabel': 'HISTORIA PERSONAL',

  // ── FilterBar ──
  'fans.filter.all': 'TODAS LAS HISTORIAS',
  'fans.filter.discipline': 'DISCIPLINA',
  'fans.filter.mentalHealth': 'SALUD MENTAL',
  'fans.filter.fitness': 'FITNESS',
  'fans.filter.business': 'NEGOCIOS',
  'fans.filter.family': 'FAMILIA',
  'fans.filter.faith': 'FE',
  'fans.filter.dueProcess': 'DEBIDO PROCESO',

  // ── FinalCTA ──
  'fans.finalCta.title': 'EL IMPACTO NO PUEDE REDUCIRSE A UN TITULAR',
  'fans.finalCta.body': 'Las figuras públicas suelen ser juzgadas a través de clips aislados, acusaciones y controversias. Estos testimonios documentan otra parte de la historia: las personas que reconocen en Andrew y Tristan Tate una fuente de disciplina, responsabilidad, resiliencia, fe, mejora física y ambición personal.',
  'fans.finalCta.readTateStory': 'LEER LA HISTORIA DE LOS TATE',
  'fans.finalCta.exploreLegal': 'EXPLORAR LOS CASOS LEGALES',
  'fans.finalCta.signPetition': 'FIRMAR LA PETICIÓN',

  // ── GlobalImpact ──
  'fans.globalImpact.title': 'IMPACTO MÁS ALLÁ DE LOS TITULARES',
  'fans.globalImpact.body': 'Las personas representadas aquí describen cambios en disciplina, salud física, resiliencia mental, negocios, fe, relaciones familiares y un renovado sentido de propósito.',
  'fans.globalImpact.discipline': 'DISCIPLINA',
  'fans.globalImpact.mentalResilience': 'RESILIENCIA MENTAL',
  'fans.globalImpact.fitness': 'FITNESS',
  'fans.globalImpact.business': 'NEGOCIOS',
  'fans.globalImpact.family': 'FAMILIA',
  'fans.globalImpact.faith': 'FE',

  // ── LegalDisclaimer ──
  'fans.legal.title': 'AVISO LEGAL Y EDITORIAL',
  'fans.legal.p1': 'Los testimonios publicados en esta página reflejan las opiniones individuales y las experiencias relatadas por sus respectivos autores. La publicación no implica que Tate Protest haya verificado de forma independiente cada afirmación factual. Los testimonios se presentan con fines de interés público, defensa e información, y no constituyen testimonio legal ni prueba judicial.',
  'fans.legal.p2': 'Los testimonios reflejan las opiniones personales y experiencias de sus respectivos autores. Tate Protest no verifica de forma independiente cada declaración o afirmación. Los nombres se muestran tal como fueron publicados en Change.org o según fueron enviados por los autores.',

  // ── ShortStatements ──
  'fans.shortStatements.label': 'DECLARACIONES BREVES',
  'fans.shortStatements.ariaPrev': 'Declaraciones anteriores',
  'fans.shortStatements.ariaNext': 'Declaraciones siguientes',

  // ── SubmitTestimonial ──
  'fans.submit.title': 'COMPARTE EL IMPACTO',
  'fans.submit.body': 'Los seguidores pueden enviar sus propios relatos sobre cómo el contenido, los negocios, las enseñanzas o la experiencia legal de Andrew o Tristan Tate afectaron sus vidas y perspectivas.',
  'fans.submit.btn': 'ENVIAR UN TESTIMONIO',
  'fans.submit.successTitle': 'Gracias',
  'fans.submit.successBody': 'Tu testimonio ha sido recibido. Será revisado antes de su publicación.',
  'fans.submit.labelName': 'Nombre visible o iniciales *',
  'fans.submit.placeholderName': 'Ej. Juan D.',
  'fans.submit.labelTestimonial': 'Tu testimonio *',
  'fans.submit.placeholderTestimonial': 'Comparte tu experiencia...',
  'fans.submit.labelCountry': 'País (opcional)',
  'fans.submit.placeholderCountry': 'Ej. México',
  'fans.submit.labelCategory': 'Categoría de impacto (opcional)',
  'fans.submit.selectCategory': 'Selecciona una categoría',
  'fans.submit.categoryOther': 'Otra',
  'fans.submit.checkGenuine': 'Confirmo que este envío refleja mi experiencia personal genuina.',
  'fans.submit.checkPermission': 'Autorizo a Tate Protest a publicar este testimonio usando el nombre o las iniciales proporcionadas.',
  'fans.submit.submitBtn': 'ENVIAR TESTIMONIO',
  'fans.submit.cancel': 'Cancelar',
  'fans.submit.errorConnection': 'No se pudo enviar. Comprueba tu conexión e inténtalo de nuevo.',

  // ── TestimonialGrid ──
  'fans.grid.empty': 'No se encontraron testimonios para esta categoría.',

  // ── donate/page.tsx ──
  'donate.hero.titleSuccess': 'GRACIAS',
  'donate.hero.titleDefault': 'APOYA LA LUCHA',
  'donate.hero.subtitleSuccess': 'Tu apoyo marca la diferencia',
  'donate.hero.subtitleDefault': 'Ayúdanos a organizarnos, documentar e informar',
  'donate.hero.imgAlt': 'Fondo cinematográfico abstracto oscuro',

  'donate.success.title': 'GRACIAS POR APOYAR TATE PROTEST',
  'donate.success.body': 'Tu contribución ayuda a Tate Protest a continuar su trabajo independiente promoviendo la transparencia, el debido proceso y la defensa pacífica y legal.',
  'donate.success.shareTateProtest': 'COMPARTIR TATE PROTEST',
  'donate.success.signPetition': 'FIRMAR LA PETICIÓN',
  'donate.success.returnHome': 'VOLVER AL INICIO',
  'donate.success.shareText': 'Acabo de apoyar Tate Protest — una plataforma independiente que promueve la transparencia y el debido proceso. Más información:',

  'donate.form.sectionTitle': 'AYÚDANOS A ORGANIZARNOS, DOCUMENTAR E INFORMAR',
  'donate.form.sectionBody': 'Tu contribución apoya la coordinación legal de eventos, la investigación de información pública, materiales de difusión, operaciones del sitio web y la tecnología necesaria para mantener informados a los seguidores.',
  'donate.form.noticeBody': 'Cada contribución —grande o pequeña— ayuda a Tate Protest a continuar su defensa independiente por la transparencia, el debido proceso y los procedimientos legales justos.',

  'donate.method.choose': 'Elige un método de contribución',
  'donate.method.cardTitle': 'Tarjeta',
  'donate.method.cardDescription': 'Contribución única o mensual a través de Stripe.',
  'donate.method.cryptoTitle': 'USDT en Solana',
  'donate.method.cryptoDescription': 'Envía una transferencia directa a una billetera. No necesitas conectar una billetera.',
  'donate.crypto.token': 'Token · USDT',
  'donate.crypto.network': 'Red · Solana',
  'donate.crypto.title': 'Envía USDT directamente',
  'donate.crypto.intro': 'Usa tu billetera o la opción de retiro de tu exchange para transferir USDT a la dirección indicada.',
  'donate.crypto.recipientLabel': 'Dirección de la billetera destinataria',
  'donate.crypto.viewExplorer': 'Ver en Solscan',
  'donate.crypto.addressAccessibleLabel': 'Dirección completa del destinatario de USDT en Solana',
  'donate.crypto.copyAddress': 'Copiar dirección',
  'donate.crypto.copySuccess': 'Dirección copiada. Confirma el token, la red y la dirección completa en tu billetera antes de enviar.',
  'donate.crypto.copyError': 'No se pudo copiar automáticamente. Selecciona la dirección completa de arriba y cópiala manualmente.',
  'donate.crypto.manualCopy': '¿No funciona la copia? Selecciona la dirección completa de arriba y cópiala manualmente.',
  'donate.crypto.stepsTitle': 'Pasos para transferir',
  'donate.crypto.step1': 'Abre tu billetera o exchange y elige enviar o retirar USDT.',
  'donate.crypto.step2': 'Selecciona la red Solana y pega la dirección destinataria indicada.',
  'donate.crypto.step3': 'Confirma USDT, Solana y la dirección completa del destinatario antes de aprobar la transferencia.',
  'donate.crypto.networkWarning': 'Envía ÚNICAMENTE USDT por Solana. No uses Ethereum, TRON ni ninguna otra red.',
  'donate.crypto.irreversible': 'Las transferencias son irreversibles. Tu billetera puede necesitar SOL para pagar las comisiones de red de Solana.',
  'donate.crypto.directTransfer': 'Esta es una transferencia directa a una billetera. El sitio no confirma automáticamente la recepción ni emite un recibo.',

  'donate.priority.label': 'PRIORIDAD ACTUAL',
  'donate.priority.title': 'PRÓXIMA FECHA JUDICIAL: DESCONOCIDA',
  'donate.priority.body': 'Apoya la investigación de información pública, las comunicaciones, la difusión y las actualizaciones del caso mientras no se anuncie una nueva fecha judicial.',

  'donate.largeContrib.title': '¿PLANEAS UNA CONTRIBUCIÓN GRANDE?',
  'donate.largeContrib.body': 'Para contribuciones de $2,500 o más, contacta a Tate Protest para completar la verificación de identidad y acordar los métodos de pago aprobados.',
  'donate.largeContrib.btn': 'CONTACTAR AL EQUIPO DE CONTRIBUCIONES',
  'donate.largeContrib.warning': 'Nunca envíes información bancaria o financiera a través de un correo electrónico no verificado, cuenta de redes sociales o mensaje directo.',

  'donate.sidebar.howUsedTitle': 'Cómo pueden usarse las contribuciones',
  'donate.sidebar.howUsedFootnote': 'Estos ejemplos ilustran posibles usos de las contribuciones. Los gastos reales dependen de las necesidades operativas y de campaña actuales.',

  'donate.sidebar.howUsed.25.title': 'Materiales de difusión',
  'donate.sidebar.howUsed.25.desc': 'Ayuda a financiar materiales de información pública impresos y digitales.',
  'donate.sidebar.howUsed.50.title': 'Suministros para manifestaciones',
  'donate.sidebar.howUsed.50.desc': 'Ayuda a proveer carteles, pancartas, agua, materiales de identificación y suministros para eventos pacíficos.',
  'donate.sidebar.howUsed.100.title': 'Investigación y comunicaciones',
  'donate.sidebar.howUsed.100.desc': 'Apoya la investigación de registros públicos, documentación de casos, operaciones del sitio web y comunicaciones con seguidores.',
  'donate.sidebar.howUsed.500.title': 'Coordinación de eventos',
  'donate.sidebar.howUsed.500.desc': 'Contribuye a la logística legal de eventos, equipamiento, permisos cuando se requieran y difusión pública coordinada.',

  'donate.sidebar.secureTitle': 'Procesamiento seguro de pagos',
  'donate.sidebar.secure1': 'Los pagos se procesan de forma segura a través de Stripe',
  'donate.sidebar.secure2': 'Tate Protest no recibe ni almacena directamente información completa de tarjetas',
  'donate.sidebar.secure3': 'Las tarifas estándar de procesamiento de pagos pueden deducirse de las contribuciones',

  'donate.sidebar.transparencyTitle': 'Transparencia de contribuciones',
  'donate.sidebar.recipient.label': 'Destinatario: Tate Protest',
  'donate.sidebar.useOfFunds.label': 'Uso de los fondos',
  'donate.sidebar.useOfFunds.value': 'Las contribuciones apoyan la defensa independiente de Tate Protest, comunicaciones, investigación, operaciones del sitio web, difusión y coordinación legal de eventos.',
  'donate.sidebar.affiliation.label': 'Afiliación',
  'donate.sidebar.affiliation.value': 'Las contribuciones no se pagan a Andrew Tate, Tristan Tate, sus familias, abogados ni defensa legal, salvo que se divulgue expresa y públicamente.',
  'donate.sidebar.processing.label': 'Procesamiento',
  'donate.sidebar.processing.value': 'Los pagos son procesados por Stripe y pueden estar sujetos a tarifas estándar de procesamiento.',

  'donate.sidebar.questions': '¿Tienes preguntas sobre cómo contribuir?',
  'donate.sidebar.contactUs': 'Contáctanos',
  'donate.sidebar.questionsEnd': 'y te responderemos en un plazo de 24 horas.',

  'donate.transparency.title': 'TRANSPARENCIA EN ACCIÓN',
  'donate.transparency.body': 'Tate Protest se compromete a mostrar a los seguidores cómo las contribuciones ayudan a impulsar la defensa pacífica, la investigación pública, la difusión y la coordinación de eventos.',
  'donate.transparency.campaignGoal': 'META DE CAMPAÑA',
  'donate.transparency.amountRaised': 'MONTO RECAUDADO',
  'donate.transparency.eventExpenses': 'GASTOS DEL EVENTO',
  'donate.transparency.completedInitiatives': 'INICIATIVAS COMPLETADAS',
  'donate.transparency.photosResults': 'FOTOS / RESULTADOS',
  'donate.transparency.pending': 'Los informes de campaña se publicarán cuando las cifras verificadas estén disponibles.',

  // ── DonationForm ──
  'donate.donationForm.terminal': 'terminal seguro de donaciones',
  'donate.donationForm.cancelledMsg': 'Tu contribución no fue completada. Si encontraste algún problema, inténtalo de nuevo o',
  'donate.donationForm.cancelledContact': 'contáctanos',
  'donate.donationForm.oneTime': 'Una vez',
  'donate.donationForm.monthly': 'Mensual',
  'donate.donationForm.monthlyNote': 'Contribución mensual recurrente — cancela cuando quieras',
  'donate.donationForm.selectAmount': '> seleccionar_monto_de_contribución',
  'donate.donationForm.other': '> OTRO',
  'donate.donationForm.enterAmount': 'Ingresa el monto',
  'donate.donationForm.nameLabel': '> nombre',
  'donate.donationForm.nameOptional': '// opcional',
  'donate.donationForm.namePlaceholder': 'Tu nombre',
  'donate.donationForm.emailLabel': '> correo electrónico',
  'donate.donationForm.emailOptional': '// opcional',
  'donate.donationForm.emailPlaceholder': 'tu@ejemplo.com',
  'donate.donationForm.messageLabel': '> mensaje_de_apoyo',
  'donate.donationForm.messageOptional': '// opcional',
  'donate.donationForm.messagePlaceholder': 'Por qué esta causa te importa...',
  'donate.donationForm.redirecting': 'redirigiendo_al_pago...',
  'donate.donationForm.contributeBtn': '> CONTRIBUIR {{amount}} DE FORMA SEGURA',
  'donate.donationForm.securityNote': '// procesamiento seguro de pagos // impulsado por stripe',
  'donate.donationForm.errorDefault': 'Algo salió mal. Por favor, inténtalo de nuevo.',
};
